export function dedupeCanonicalEvents(events) {
  const list = Array.isArray(events) ? events : [];
  const map = new Map();
  for (const e of list) {
    if (!e || !e.id) continue;
    const canonicalId = e.originalEventId || e.id;
    const current = map.get(canonicalId);
    if (!current) {
      map.set(canonicalId, e);
      continue;
    }
    const currentIsCopy = !!current.originalEventId;
    const candidateIsCopy = !!e.originalEventId;
    if (currentIsCopy && !candidateIsCopy) {
      map.set(canonicalId, e);
    }
  }
  return Array.from(map.values());
}
